import { render, staticRenderFns } from "./ProgressFollowed.vue?vue&type=template&id=c4ec79ea&scoped=true&"
import script from "./ProgressFollowed.vue?vue&type=script&lang=js&"
export * from "./ProgressFollowed.vue?vue&type=script&lang=js&"
import style0 from "./ProgressFollowed.vue?vue&type=style&index=0&id=c4ec79ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ec79ea",
  null
  
)

export default component.exports